import * as s from "react";
import i from "../lib/IconBase.es.js";
import e from "../defs/MagnifyingGlassPlus.es.js";
const a = s.forwardRef((o, n) => /* @__PURE__ */ s.createElement(i, { ref: n, ...o, weights: e }));
a.displayName = "MagnifyingGlassPlusIcon";
const f = a;
export {
  f as MagnifyingGlassPlus,
  a as MagnifyingGlassPlusIcon
};
